module.exports = __webpack_public_path__ + "img/process_table.53facc7a.png";